import {cs}            from "@Common/react/chain-services";
import {keyed1}        from "@Common/react/keyed";
import {UseState}      from "@Common/react/use-state";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

import {ModalLayout} from "../../../common/modal-layout/modal-layout";

import {ImageEffectsMode}     from "./image-effects-mode/image-effects-mode";
import {NormalMode}           from "./normal-mode/normal-mode";
import {RemoveBackgroundMode} from "./remove-bg-mode/remove-bg-mode";

export const ImageAssetEditModal = (
    {
        onRemoveBackground=undefined,
        onEdit,
        onImageEdit,
        onDelete,
        agentId,
        build3Customize = false,
        allowDefaultOption = true,
        next: rootNext,
    } : {
        onRemoveBackground?:any,
        onEdit:any,
        onImageEdit:any,
        onDelete:any,
        agentId:any,
        build3Customize?:boolean,
        allowDefaultOption?:number | boolean,
        next:any,
    }
) => cs(
    ["modal", ({}, next) => ModalService3<any>({
        urlParam: "edit",
        ignorePassiveClose: true,
        contentService: ({params, close, next: next1}) => next({
            data: params.data,
            type: params.type,
            typeLabel: params.typeLabel,
            close,
            next: next1,
        }),
        xdQaName: "Image Edit Modal",
        rootNext,
    })],
    ["modeState", (_, next) => UseState({
        initValue: "normal",
        // initValue: isDevQuan() ? "image-fx" : "normal",
        next,
    })],
    ({modeState}, next) => keyed1({key: modeState.value, next}),
    ({modeState, modal}) => (
        modeState.value === "image-fx" ? ImageEffectsMode({
            modal,
            onImageEdit,
            data: modal.data,
            typeLabel: modal.typeLabel ?? modal.type,
            next: modal.next,
        }) : cs(
            ["mode", ({}, next) => modeState.value === "remove-bg" ? RemoveBackgroundMode({
                agentId,
                cancel     : () => modeState.onChange("normal"),
                closeModal : () => {
                    modeState.onChange("normal");
                    modal.close();
                },
                headshot   : modal.data,
                typeLabel   : modal.typeLabel ?? modal.type,
                onDone: (result) => onRemoveBackground?.(modal.data, result),
                ...!build3Customize && {
                    allowDefaultOption,
                },
                next
            }) : NormalMode({
                modal,
                onEdit,
                onDelete,
                onImageEffects: () => modeState.onChange("image-fx"),
                ...!build3Customize && {
                    onRemoveBackground: () => modeState.onChange("remove-bg"),
                    allowDefaultOption,
                },
                typeLabel   : modal.typeLabel ?? modal.type,
                next
            })],
            ({mode}, next) => modal.next({
                width: mode.width ?? 600,
                onPassiveClose: mode.onPassiveClose,
                content: next(),
            }),

            ({mode}) => ModalLayout({
                title: "Edit " + (modal.typeLabel ?? modal.type),
                content: mode.render(),
                buttons: [
                    modeState.value === "normal" ? {
                        label: "Cancel",
                        onClick: () => modal.close(),
                    } : {
                        label: "Back",
                        onClick: () => {
                            modeState.onChange("normal");
                            mode.onCancel?.();
                        },
                    },
                    {
                        label: "Save",
                        disabled: mode.isDisabled,
                        primary: true,
                        onClick: mode.onSave
                    },
                ],
            }),
        )
    ),
);

